import userProfileFormModel from "./userProfileFormModel";

const formField = userProfileFormModel.formField;

export default {
    [formField.company_name.name]: "XYZ Company Ltd",
    [formField.dealer_code.name]: "XY-3578",
    [formField.email_address.name]: "xyz@xyz.com",
    [formField.first_name.name]: "Ashfaque Z.",
    [formField.last_name.name]: "Rahman",
    [formField.city.name]: "Melbourne",
    [formField.state.name]: "Vic",
    [formField.postal_code.name]: "",
    [formField.about_me.name]: "Lorem ipsum"
}